import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/meetings`;
export const list     = (wsId, params = {}) => { const q = Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : ''; return get(`${base(wsId)}${q}`); };
export const upcoming = (wsId)              => get(`${base(wsId)}/upcoming`);
export const create   = (wsId, body)        => post(base(wsId), body);
export const getOne   = (wsId, id)          => get(`${base(wsId)}/${id}`);
export const update   = (wsId, id, body)    => patch(`${base(wsId)}/${id}`, body);
export const remove   = (wsId, id)          => del(`${base(wsId)}/${id}`);
